import React, { useEffect, useState } from 'react';
import "./LeafletMap.css"
import { MapContainer, TileLayer} from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
import {Marker} from 'react-leaflet'
import Markers from './Markers';
import { Geolocation } from '@capacitor/geolocation';

import {useTranslation} from 'react-i18next'

import { changeLanguage } from 'i18next';

import icon from '../assets/logo.svg';

import polosEsp from '../data/podebi_es.json'
import polosEn from '../data/podebi_en.json'
import polosFr from '../data/podebi_fr.json'
import polosCh from '../data/podebi_ch.json'
import polosMay from '../data/podebi_may.json'

import art_qroo from '../data/Corredor/artesanias_qroo.json'

import instalEsp from '../data/instalacionesenergia_es.json'
import instalEn from '../data/instalacionesenergia_en.json'
import instalFr from '../data/instalacionesenergia_fr.json'
import instalCh from '../data/instalacionesenergia_ch.json'
import instalMay from '../data/instalacionesenergia_may.json'

import infraeEsp from '../data/infraestructura_es.json'
import infraeEn from '../data/infraestructura_en.json'
import infraeFr from '../data/infraestructura_fr.json'
import infraeCh from '../data/infraestructura_ch.json'
import infraeMay from '../data/infraestructura_may.json'

import inter from '../data/estacionesCordoba.json'

import dataMuseumsEsp from '../data/museos_nal_es.json'
import dataMuseumsEng from '../data/museos_nal_en.json'
import dataMuseumsFr from '../data/museos_nal_fr.json'
import dataMuseumsCh from '../data/museos_nal_ch.json'
import dataMuseumsMay from '../data/museos_nal_may.json'

import dataBancosEsp from '../data/bancos-bienestar_es.json'
import dataBancosEng from '../data/bancos-bienestar_en.json'
import dataBancosFr from '../data/bancos-bienestar_fr.json'
import dataBancosCh from '../data/bancos-bienestar_ch.json'
import dataBancosMay from '../data/bancos-bienestar_may.json'

import dataRestaurantesEsp from '../data/restaurantes_pos_es.json'
import dataRestaurantesEng from '../data/restaurantes_pos_en.json'
import dataRestaurantesFr from '../data/restaurantes_pos_fr.json'
import dataRestaurantesCh from '../data/restaurantes_pos_ch.json'
import dataRestaurantesMay from '../data/restaurantes_pos_may.json'

import dataCooperativasEsp from '../data/cooperativas_pos_es.json'
import dataCooperativasEng from '../data/cooperativas_pos_en.json'
import dataCooperativasFr from '../data/cooperativas_pos_fr.json'
import dataCooperativasCh from '../data/cooperativas_pos_ch.json'
import dataCooperativasMay from '../data/cooperativas_pos_may.json'

import dataFinanciera from '../data/financiera_pos.json'

import dataArtesanias from '../data/artesanias_yuc.json'
import dataPoesia from '../data/poesia.json'
import dataLegadoMexico from '../data/legadomexalmundo.json'


import dataPueblosMagicosEsp from '../data/pueblosmagicos_pos_es.json'
import dataPueblosMagicosFr from '../data/pueblosmagicos_pos_fr.json'
import dataPueblosMagicosEn from '../data/pueblosmagicos_pos_en.json'
import dataPueblosMagicosCh from '../data/pueblosmagicos_pos_ch.json'
import dataPueblosMagicosMay from '../data/pueblosmagicos_pos_may.json'

import dataTurComEsp from '../data/maya-ka-an.json'
import dataTurComMaya from '../data/maya-ka-an-lang-maya.json'
import dataTurComEng from '../data/maya-ka-an-lang-english.json'
import dataTurComFren from '../data/maya-ka-an-lang-french.json'
import dataTurComChin from '../data/maya-ka-an-lang-chinese.json'

import dataSitiosArqEsp from '../data/sitios_arqueologicos.json'
import dataSitiosArqMaya from '../data/sitios_arqueologicos_may.json'
import dataSitiosArqEng from '../data/sitios_arqueologicos_en.json'
import dataSitiosArqFren from '../data/sitios_arqueologicos_fr.json'
import dataSitiosArqChin from '../data/sitios_arqueologicos_ch.json'

import estacionesEsp from "../data/estacionesparaderostrenmaya.json"
import estacionesEn from "../data/estacionesparaderostrenmaya_en.json"
import estacionesFr from "../data/estacionesparaderostrenmaya_fr.json"
import estacionesCh from "../data/estacionesparaderostrenmaya_ch.json"
import estacionesMay from "../data/estacionesparaderostrenmaya_may.json"

import dataExpYucatanEsp from '../data/experiencias_f1_es.json'
import dataExpYucatanEn from '../data/experiencias_f1_en.json'
import dataExpYucatanFr from '../data/experiencias_f1_fr.json'
import dataExpYucatanCh from '../data/experiencias_f1_ch.json'
import dataExpYucatanMay from '../data/experiencias_f1_may.json'

import dataSabYucatanEsp from '../data/datasabores_f1_es.json'
import dataSabYucatanEn from '../data/datasabores_f1_en.json'
import dataSabYucatanFr from '../data/datasabores_f1_fr.json'
import dataSabYucatanCh from '../data/datasabores_f1_ch.json'
import dataSabYucatanMay from '../data/datasabores_f1_may.json'

import dataPlatillosQRooEsp from '../data/data_cocinaqroo_es.json'
import dataPlatillosQRooEn from '../data/data_cocinaqroo_en.json'
import dataPlatillosQRooFr from '../data/data_cocinaqroo_fr.json'
import dataPlatillosQRooCh from '../data/data_cocinaqroo_ch.json'
import dataPlatillosQRooMay from '../data/data_cocinaqroo_may.json'

import MarkersSites from './MarkersSites';
import MarkersSitesB from './MarkersSitesB';
import MarkersSitesC from './MarkersSitesC';
import MarkersSitesD from './MarkersSitesD';
import MarkersSitesE from './MarkersSitesE';
import MarkersSitesF from './MarkersSitesF';
import MarkersSitesG from './MarkersSitesG';
import MarkersSitesH from './MarkersSitesH';
import MarkersSitesI from './MarkersSitesI';
import MarkersSitesJ from './MarkersSitesJ';
import MarkersSitesK from './MarkersSitesK';
import MarkersSitesL from './MarkersSitesL';
import MarkersSitesM from './MarkersSitesM';
import MarkersSitesN from './MarkersSitesN';


const CurrentIcon = L.icon({
    iconUrl: icon,
    iconSize:     [30, 30], // size of the icon
});

const LeafletMap: React.FC = () => {
    const [t,i18n] = useTranslation("global");

    console.log('Language: ',i18n.language);

    const [state, setstate] = useState({
        currentLocation: {
            lat:19.441221,
            lng:-88.992000
        }
    });

    const langEnable = i18n.language;

    let dataTurCom = dataTurComMaya;
    let dataSitiosArq = dataSitiosArqEsp;
    let dataPueblosMagicos = dataPueblosMagicosEsp;
    let estaciones = estacionesEsp;
    let polos = polosEsp;
    let instal = instalEsp;
    let infrae = infraeEsp;
    let dataMuseums = dataMuseumsEsp;
    let dataBancos = dataBancosEsp;
    let dataRestaurantes = dataRestaurantesEsp;
    let dataCooperativas = dataCooperativasEsp;
    let dataExpYucatan = dataExpYucatanEsp;
    let dataSabYucatan = dataSabYucatanEsp;
    let dataPlatillosQRoo = dataPlatillosQRooEsp;
  
  
  switch(langEnable){
      case 'es':
        dataTurCom = dataTurComEsp;
        dataSitiosArq = dataSitiosArqEsp
        dataPueblosMagicos = dataPueblosMagicosEsp
        estaciones = estacionesEsp
        polos = polosEsp
        instal = instalEsp
        infrae = infraeEsp
        dataMuseums = dataMuseumsEsp
        dataBancos = dataBancosEsp
        dataRestaurantes = dataRestaurantesEsp
        dataCooperativas = dataCooperativasEsp
        dataExpYucatan = dataExpYucatanEsp
        dataSabYucatan = dataSabYucatanEsp
        dataPlatillosQRoo = dataPlatillosQRooEsp

          break;
      case 'en':
        dataTurCom = dataTurComEng;
        dataSitiosArq = dataSitiosArqEng
        dataPueblosMagicos = dataPueblosMagicosEn
        estaciones = estacionesEn
        polos = polosEn
        instal = instalEn
        infrae = infraeEn
        dataMuseums = dataMuseumsEng
        dataBancos = dataBancosEng
        dataRestaurantes = dataRestaurantesEng
        dataCooperativas = dataCooperativasEng
        dataExpYucatan = dataExpYucatanEn
        dataSabYucatan = dataSabYucatanEn
        dataPlatillosQRoo = dataPlatillosQRooEn
          break;
      case 'fr':
        dataTurCom = dataTurComFren;
        dataSitiosArq = dataSitiosArqFren
        dataPueblosMagicos = dataPueblosMagicosFr
        estaciones = estacionesFr
        polos = polosFr
        instal = instalFr
        infrae = infraeFr
        dataMuseums = dataMuseumsFr
        dataBancos = dataBancosFr
        dataRestaurantes = dataRestaurantesFr
        dataCooperativas = dataCooperativasFr
        dataExpYucatan = dataExpYucatanFr
        dataSabYucatan = dataSabYucatanFr
        dataPlatillosQRoo = dataPlatillosQRooFr
          break;
      case 'zh':
        dataTurCom = dataTurComChin;
        dataSitiosArq = dataSitiosArqChin
        dataPueblosMagicos = dataPueblosMagicosCh
        estaciones = estacionesCh
        polos = polosCh
        instal = instalCh
        infrae = infraeCh
        dataMuseums = dataMuseumsCh
        dataBancos = dataBancosCh
        dataRestaurantes = dataRestaurantesCh
        dataCooperativas = dataCooperativasCh
        dataExpYucatan = dataExpYucatanCh
        dataSabYucatan = dataSabYucatanCh
        dataPlatillosQRoo = dataPlatillosQRooCh
          break;
      case 'maya':
        dataTurCom = dataTurComMaya;
        dataSitiosArq = dataSitiosArqMaya
        dataPueblosMagicos = dataPueblosMagicosMay
        estaciones = estacionesMay
        polos = polosMay
        instal = instalMay
        infrae = infraeMay
        dataMuseums = dataMuseumsMay
        dataBancos = dataBancosMay
        dataRestaurantes = dataRestaurantesMay
        dataCooperativas = dataCooperativasMay
        dataExpYucatan = dataExpYucatanMay
        dataSabYucatan = dataSabYucatanMay
        dataPlatillosQRoo = dataPlatillosQRooMay
          break;
  }
  

    const GetCurrentPosition = async () => {
        const [t,i18n] = useTranslation("global");

        const coordinates = await Geolocation.getCurrentPosition({enableHighAccuracy:true});
        setstate({currentLocation:{
            lat: coordinates.coords.latitude,
            lng: coordinates.coords.longitude
        }});
        console.log('Current position:', coordinates);
        console.log('Language: ',i18n.language);
      };

    useEffect(() => {
        window.dispatchEvent(new Event("resize"));

        const checkPermission = async () => {
            try {
                const status = await Geolocation.checkPermissions();
                if (status.coarseLocation) {
                    return true;
                }
            return false;
            } catch (error:any) {
                console.log(error.message);
            }
        };
        checkPermission();
        //GetCurrentPosition();
      }, []);

    /*useEffect(()=>{
        setTimeout(() => {
            GetCurrentPosition();
        }, 1000);
      },[state]);*/

    return (
        <MapContainer center={[state.currentLocation.lat,state.currentLocation.lng]} zoom={6}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'
            />
            <MarkersSitesN sitios={estaciones} Icon='/assets/icon/tren-bala-circle.svg'/>
            <Markers sitios={polos} Icon='/assets/icon/polo-desarrollo-circle.svg'/>
            <Markers sitios={art_qroo} Icon='/assets/icon/artesania-circle.svg'/>
            <Markers sitios={instal} Icon='/assets/icon/petroleo-circle.svg'/>
            <Markers sitios={infrae} Icon='/assets/icon/petroleo-circle.svg'/>
            <Markers sitios={inter} Icon='/assets/icon/tren-inter-circle.svg'/>
            <MarkersSites sitios={dataMuseums} Icon='/assets/icon/chac-circle.svg'></MarkersSites>
            <MarkersSitesB sitios={dataBancos} Icon='/assets/icon/banco-circle.svg'></MarkersSitesB>
            <MarkersSitesC sitios={dataSitiosArq} Icon='/assets/icon/piramide-circle.svg'></MarkersSitesC>
            <MarkersSitesD sitios={dataRestaurantes} Icon='/assets/icon/molcajete-circle.svg'></MarkersSitesD>
            <MarkersSitesE sitios={dataCooperativas} Icon='/assets/icon/cooperativa-circle.svg'></MarkersSitesE>
            <MarkersSitesF sitios={dataFinanciera} Icon='/assets/icon/teatroicon.png'></MarkersSitesF>
            <MarkersSitesG sitios={dataPueblosMagicos} Icon='/assets/icon/pueblosmagicoslb.png'></MarkersSitesG>
            <MarkersSitesI sitios={dataExpYucatan} Icon='/assets/icon/exp.png'></MarkersSitesI>
            <MarkersSitesJ sitios={dataSabYucatan} Icon='/assets/icon/sabores.png'></MarkersSitesJ>
            <MarkersSitesH sitios={dataTurCom} Icon='/assets/icon/icono-maya-kaan.png'></MarkersSitesH>
            <MarkersSitesK sitios={dataPlatillosQRoo} Icon='/assets/icon/recetas.png'></MarkersSitesK>
            <MarkersSitesL sitios={dataArtesanias} Icon='/assets/icon/artesaniasp.png'></MarkersSitesL>
            <MarkersSitesL sitios={dataPoesia} Icon='/assets/icon/poesia.png'></MarkersSitesL>
            <MarkersSitesM sitios={dataLegadoMexico} Icon='/assets/icon/creadomexico.png'></MarkersSitesM>

            {/*<Marker position={[state.currentLocation.lat,state.currentLocation.lng]} icon={CurrentIcon}></Marker>*/}
        </MapContainer>
    );
};

export default LeafletMap;